<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-row>
            <v-col cols="4">
                <v-select dense v-model="selected_ay" :items="aylist" item-text="name" item-value="id" label="AcademicYear" persistent-hint single-line></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Class List
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="divisiondata" :search="search">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-btn title="Add" class="ma-2" tile small @click="editItem(item)"><v-icon color="primary">mdi-plus-circle-outline</v-icon> </v-btn>

                            <v-btn title="Edit" class="ma-2" tile small @click="editattendance(item)">
                                <v-icon color="success">mdi-pencil</v-icon>
                            </v-btn>

                            <v-btn title="Export" class="ma-2" tile small @click="exportattendace(item)"><v-icon color="warning">mdi-export</v-icon> </v-btn>
                            <v-btn title="Re-Arrange Day Number" class="ma-2" tile small loading:loader_rearrange @click="rearrangedayno(item)"><v-icon color="warning">mdi-account-convert-outline</v-icon> </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            headers: [
                { text: "Year", value: "year" },
                { text: "Division", value: "division" },
                { text: "Number of Students", value: "numstudents" },
                { text: "Total Days", value: "numdays" },
                { text: "Attendance Actions", value: "action", sortable: false },
            ],
            selected_ay: "",
            aylist: "",
            search: "",
            divisiondata: "",
            loader_rearrange: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            editedItem: {
                divoff: "",
                year: "",
                division: "",
                numstudents: "",
                numdays: "",
            },
        }),

        mounted() {
            this.getDivisionData();
        },
        methods: {
            rearrangedayno(item) {
                const data = {
                    divoff: item.divoff,
                };
                this.loader_rearrange = true;
                axios
                    .post("/Academics/rearrangedayno", data)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.getDivisionData();
                            this.loader_rearrange = false;
                            this.showSnackbar("#4caf50", "Re-arranged Successfully..."); //res.data.status;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            getDivisionData() {
                axios
                    .post("/Academics/getDivisionData")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.divisiondata = res.data.divisiondata;
                            this.aylist = res.data.aylist;
                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            editItem(item) {
                // alert('stting')
                this.editedIndex = this.divisiondata.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.$store.commit("setdivoff_id", this.editedItem.divoff);
                //this.dialog = true;
                this.getDivisionStudents();
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getDivisionStudents() {
                //  alert('calling'+this.editedItem.divoff)

                this.$router.push({ name: "mark-attendance" });
            },
            exportattendace(item) {
                this.editedIndex = this.divisiondata.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.$store.commit("setdivoff_id", this.editedItem.divoff);
                this.$router.push({ name: "export-attendance" });
            },
            editattendance(item) {
                this.editedIndex = this.divisiondata.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.$store.commit("setdivoff_id", this.editedItem.divoff);
                this.$router.push({ name: "edit-attendance" });
            },
        },
    };
</script>
